import { FC } from "react";
import { LoadingIndicator } from "../../../../components/LoadingIndicator";
import { Button } from "../../../../components/Button";
import { IEnvironment } from "../../../../interfaces";

interface Props {
  env: IEnvironment;
  isUpdating: boolean;
  isDisabled: boolean;
  version: "internal" | "external";
  onUpdateInternalClick: (env: IEnvironment) => void;
  onUpdateProdClick?: (env: IEnvironment) => void;
}

export const TranslationUpdaterItem: FC<Props> = ({
  env,
  isUpdating,
  isDisabled,
  version,
  onUpdateInternalClick,
  onUpdateProdClick,
}) => {
  const getUpdateInternalButtonDisability = () => {
    if (!env?.url && !env?.uat) {
      return true;
    }

    return isDisabled;
  };

  const renderUpdatingState = () => (
    <div
      className="translation-updater-list-item-loader-wrapper"
      data-testid="translation-updater-loading-indicator"
    >
      <LoadingIndicator isLoading={true} />
    </div>
  );

  const renderUpdateButtons = () => (
    <>
      <Button
        className="translation-updater-list-item-button"
        disabled={getUpdateInternalButtonDisability()}
        onClick={() => onUpdateInternalClick(env)}
      >
        {version === "internal"
          ? `Update ${env?.name.toUpperCase()}`
          : "Update UAT"}
      </Button>
      {version === "external" && (
        <Button
          className="translation-updater-list-item-button"
          disabled={isDisabled || !env?.prod}
          onClick={() => onUpdateProdClick && onUpdateProdClick(env)}
        >
          Update PROD
        </Button>
      )}
    </>
  );

  return (
    <div className="translation-updater-list-item" role="gridcell">
      <p className="translation-updater-list-item-label">{env?.name}</p>
      {isUpdating ? renderUpdatingState() : renderUpdateButtons()}
    </div>
  );
};
